// extracted by mini-css-extract-plugin
module.exports = {"ProgressBarContainer":"ScrollProgressBar_ProgressBarContainer__1IEnt","scrollBar":"ScrollProgressBar_scrollBar__2azBv"};